// Auth API methods — mixin applied to the ApiService prototype chain.
// Methods run with `this` bound to the ApiService instance, so this.request()
// and cross-domain calls resolve through the shared HttpClient base.
const withAuthApi = (Base) => class extends Base {
  // Authentication endpoints
  async login(credentials) {
    return this.request('/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials)
    });
  }

  async validateToken() {
    return this.request('/auth/validate-token', {
      method: 'GET'
    });
  }

  async signup(userData) {
    return this.request('/auth/signup', {
      method: 'POST',
      body: JSON.stringify(userData)
    });
  }

  async logout() {
    // Clear CSRF token on logout
    this.clearCSRFToken();
    
    return this.request('/auth/logout', {
      method: 'POST'
    });
  }

  async changePassword(passwordData) {
    return this.request('/change-password', {
      method: 'PUT',
      body: JSON.stringify(passwordData)
    });
  }

  async refreshToken() {
    const refreshToken = localStorage.getItem('faithinsight_refresh_token');
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }
    
    return this.request('/auth/refresh', {
      method: 'POST',
      body: JSON.stringify({ refreshToken })
    });
  }

  async forgotUsername(firstName, lastName) {
    return this.request('/auth/forgot-username', {
      method: 'POST',
      body: JSON.stringify({ firstName, lastName })
    });
  }

  async forgotPassword(email) {
    
    const result = await this.request('/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ email })
    });
    
    return result;
  }

  async resetPassword(token, newPassword) {
    return this.request('/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token, newPassword })
    });
  }


  async updateUserProfile(userData) {
    return this.request('/user/profile', {
      method: 'PUT',
      body: JSON.stringify(userData)
    });
  }


};

export default withAuthApi;
